<template>
    <section>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container d-flex flex-column bg-blue">
                    <header class="mdc-top-app-bar position-static t-color-title bg-blue">
                        <div class="mdc-top-app-bar__row">
                            <section class="mdc-top-app-bar__section title">
                                <div class="mdc-top-app-bar__title">
                                    {{$t('580')}}
                                    <!-- 구매 완료 -->
                                </div>                
                            </section>
                        </div>
                    </header>

                    <section class="flex-grow-1 scroll-y">
                        <div class="pda-default">
                            <div class="t-headline10">
                                {{$t('581')}}
                                <!-- 구매가 완료되었습니다 -->
                            </div>
                            <div class="t-body3 t-color-blue3 mgt-8">
                                {{$t('582')}} <br>
                                {{$t('587')}}
                                <!-- 강의 구매가 정상적으로 완료되었습니다.즐거운 학습 경험을 쌓아보세요! -->
                            </div>                            
                        </div>

                        <div class="round-body pdl-8 pdr-8">
                            <div class="round">
                                <div class="gradient-body">
                                    <div class="gradient"></div>
                                </div>
                            </div>
                        </div>
                        <div class="mgt-10 mgb-16 mgl-16 mgr-16 bg-white">
                            <div class="pdl-16 pdr-16 pdb-16">
                                <div class="t-subtitle2 pdt-16">
                                    {{$t('583')}}
                                    <!-- 구매 내역 -->
                                </div>
                                <div class="t-body1 mgt-10">
                                    {{goodsName}}
                                </div>

                                <hr class="divider mgt-16">
                                <div class="mgt-16">
                                    <div class="t-body3 t-color-gray2">
                                        {{$t('584')}}
                                        <!-- 학습 가능 기간 -->
                                    </div>
                                    <div class="t-body1 mgt-2">
                                        {{$moment(learningStartDatetime).format('l')}} ~ {{$moment(learningEndDatetime).format('l')}}
                                    </div>
                                </div>

                                <div class="mgt-16">
                                    <div class="t-body3 t-color-gray2">
                                        {{$t('585')}}
                                        <!-- 구매일자 -->
                                    </div>
                                    <div class="t-body1 mgt-2">
                                        {{$moment(paidDate).format('l')}}
                                    </div>
                                </div>

                                <hr class="divider mgt-16">
                                

                                <div class="mgt-16">
                                    <div class="t-body3 t-color-gray2">
                                       {{$t('586')}}
                                        <!-- 결제할 금액 -->
                                    </div>
                                    <div class="t-body1 mgt-2">
                                        {{currency}}
                                        <span class="t-color-red1 mgr-l mgr-9">{{$n(paymentPrice)}}</span>
                                    </div>
                                    
                                </div>

                                <div class="mgt-16">
                                    <div class="t-body3 t-color-gray2">
                                        {{$t('588')}}
                                        <!-- 상품 금액 -->
                                    </div>
                                    <div class="t-body1 mgt-2">
                                        {{currency}}
                                        <span class="mgr-l mgr-9">{{$n(totalPrice)}}</span>
                                    </div>
                                    
                                </div>

                                <div class="mgt-16">
                                    <div class="t-body3 t-color-gray2">
                                        {{$t('590')}}
                                        <!-- 할인된 금액 -->
                                    </div>
                                    <div class="t-body1 mgt-2">
                                        {{currency}}
                                        <span class="mgr-l mgr-9">{{$n(discountPrice)}}</span>
                                    </div>
                                    
                                </div>
                                

                            </div>
                        </div>

                    </section>

                    <section class="pda-default">
                        <div>
                            <button class="mdc-button mdc-button--raised btn-red btn-big w-full" @click="moveLearn()">
                                {{$t('592')}}
                                <!-- 지금 학습하기 -->
                            </button>
                        </div>
                        <div class="mgt-16">
                            <button class="mdc-button btn-white w-full btn-big" @click="moveList()">
                                {{$t('593')}}
                                <!-- 목록으로 돌아가기 -->
                            </button>
                        </div>
                    </section>         


                    
                    
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/**
 * 구매하기 - 결제완료(페이팔) 컴포넌트(sales - Payment completed (paypal) component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import salesApi  from '@/api/salesApi.js'
import {salesMixin} from '@/mixins/sales.js'

export default {
    mixins: [salesMixin],
    data() {
        return {
            goodsName: '',
            learningEndDatetime: '',
            learningStartDatetime: '',
            paymentPrice: '',
            totalPrice: '',
            discountPrice: '',
            currency: '',
            bankName: '',
            bankNumber: '',
            bankDepositName: '',
            deadline: '',
            paidDate: 0,
            learnerId: '',
            category: null
        }
    },

    mounted() {
        let params = {
            orderId: this.$route.params.orderId
        }

        let responseData = {}

        // get order information
        salesApi.salesOrderDetail(params).then((response) => {
            responseData = response.data.data

            this.goodsName = responseData.goods.name
            this.learningEndDatetime = Number(responseData.goods.information.learningEndDatetime || responseData.goods.information.postEndDatetime)
            this.learningStartDatetime = Number(responseData.goods.information.learningStartDatetime || responseData.goods.information.postStartDatetime)
            this.deadline = Number(responseData.deadline)
            this.paymentPrice = responseData.paymentPrice
            this.totalPrice = responseData.totalPrice
            this.discountPrice = responseData.discountPrice
            this.currency = responseData.currency

            this.paidDate = responseData.paidDate
            this.category = responseData.category

            // this.learnerId = responseData.paidData.learnerId

            // if (responseData.paymentMethod === 'bank_transfer') {
            //     this.bankName = responseData.depositAccount.bank.text
            //     this.bankNumber = responseData.depositAccount.number
            //     this.bankDepositName = responseData.depositAccount.name
            // }else {
            //     this.learnerId = responseData.paidData.learnerId
            // }

        }).catch((err) => {})
    },

}
</script>